import { Injectable, Inject, forwardRef } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { IApiresponse } from "src/app/_models/common/request-response/apiresponse";
import { IApiRequest } from "src/app/_models/common/request-response/api-request";
import { setHeader } from "src/app/_helpers/setRequestHeader";
import { ClaimsHeaderService } from "src/app/shared/claimsHeader/claims-header.service";
import {SelfSetupRequest,OrgSelfSetupDetailResponse} from "../../_models/self-setup/self-setup";
import { map, mergeMap } from "rxjs/operators";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { Claims } from "src/app/_models/common/claims";

@Injectable({
    providedIn: "root",
})
export class SelfSetupService {
    httpHeaders: HttpHeaders;
    claims: Claims;

    constructor(
        private http: HttpClient,
        private claimsHeaderService: ClaimsHeaderService,
        private claimsService: ClaimsService,
    ) {
        this.claimsService.currentClaims.subscribe((claims) => {
            this.claims = claims;
        });
     }

GetOrgSelfSetupDetail(orgId: number)
  : Observable<IApiresponse<OrgSelfSetupDetailResponse>> {

  return this.http.get<IApiresponse<OrgSelfSetupDetailResponse>>(
    `${environment.billingApiUrl}GetOrgSelfSetupDetail?organisationId=${orgId}`,
    { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
  ).pipe(
    map(data => {
        if(data.responseInfo != null){
            this.claims.SelfSetupPercentage = data.responseInfo.percentage;
            this.claimsService.updateClaims(this.claims);
        }
      return data;
    })
  );
}

SaveOrgSelfSetup(request: IApiRequest<SelfSetupRequest>): Observable<IApiresponse<OrgSelfSetupDetailResponse>> {

  const body = JSON.stringify(request);

  return this.http.post<IApiresponse<any>>(
    `${environment.billingApiUrl}SaveOrgSelfSetup`,
    body,
    { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
  ).pipe(
    mergeMap(() => this.GetOrgSelfSetupDetail(request?.requestInfo?.orgId))
  );
}
}


